import styled from '@emotion/styled';
import { Col, Row, Spin } from 'antd';
import { useMemo } from 'react';
import { useAsync } from 'react-use';
import { getOrderOverview } from 'services/api/dashboard';
import {
  last7days,
  momentDateRange2FetchParams,
  platformAll2Undefined,
  storeType2FetchParams,
} from '../../utils';
import ExtraNode from '../Filter/ExtraNode';
import FilterProvider from '../Filter/Provider';
import { useDashboardFilter, useDashboardPlatformInfo } from '../Filter/useFilter';
import TrendDrawer from '../Trend';
import TrendProvider from '../Trend/TrendProvider';
import convertData from './convertData';
import Payment from './Payment';
import PlaceOrder from './PlaceOrder';
import Profit from './Profit';
import Quiesce from './Quiesce';
import RePurchase from './RePurchase';
import Return from './Return';
import Total from './Total';

const Container = styled.div`
  margin-bottom: 16px;
`;

const initialValue = {
  storeInfo: {},
  dateRange: last7days(),
} as const;

const Content = () => {
  const filterCtx = useDashboardFilter();
  const platform = useMemo(() => {
    return platformAll2Undefined(filterCtx.platform);
  }, [filterCtx.platform]);
  const fetchParams: Dashboard.BasicParams = useMemo(() => {
    const list = filterCtx.storeInfo.list || [];

    return {
      ...momentDateRange2FetchParams(filterCtx.dateRange),
      platform,
      storeType: storeType2FetchParams(filterCtx.storeType),
      storeIds: list.map((x) => x.id),
      departmentIds: filterCtx.departments?.map((_) => _.id),
    };
  }, [
    platform,
    filterCtx.dateRange,
    filterCtx.storeType,
    filterCtx.storeInfo.list,
    filterCtx.departments,
  ]);
  const { value, loading } = useAsync(() => {
    return getOrderOverview(fetchParams).then(convertData);
  }, [fetchParams]);
  const {
    platformInfo: { isOnlyMercado, isOnlyMercadoOrOnlyTokopedia },
  } = useDashboardPlatformInfo();
  return (
    <Spin spinning={loading}>
      <Container>
        <Total value={value} />
        <Profit value={value} />
        <TrendDrawer />
        {!isOnlyMercadoOrOnlyTokopedia && <PlaceOrder value={value} />}
        {!isOnlyMercadoOrOnlyTokopedia && <Payment value={value} />}
        {!isOnlyMercado && <Quiesce value={value} />}
        <Row gutter={12}>
          <Col span={12}>
            <Return value={value} />
          </Col>
          <Col span={12}>
            <RePurchase value={value} />
          </Col>
        </Row>
      </Container>
    </Spin>
  );
};

const OrderOverview = () => {
  return (
    <FilterProvider
      initialValue={initialValue}
      rightExtra={ExtraNode}
      dashboardName="OrderOverview"
      scene="ORDER_STAT"
      showPlatformAll
    >
      <TrendProvider>
        <Content />
      </TrendProvider>
    </FilterProvider>
  );
};

export default OrderOverview;
